import { BaseError } from '../../../errors/base.js';
import { serialize } from '../../../utils/serialize.js';

class QuoteError extends BaseError {
    constructor({ quote, quoteParams, }) {
        super("Quote error", {
            details: quote == null ? "NO_QUOTE" : quote.type,
            metaMessages: [
                `Quote: ${serialize(quote)}`,
                `Quote params: ${serialize(quoteParams)}`,
            ],
            name: "QuoteError",
        });
        this.quote = quote;
        this.quoteParams = quoteParams;
    }
}

export { QuoteError };
//# sourceMappingURL=quote.js.map
